export default "__VITE_ASSET__4ab9901f__"